module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "element-top"
  }, [_c('div', [(_vm.show) ? _c('v-toolbar', {
    staticClass: "call-toolbar elevation-0",
    class: {
      'show': _vm.show
    },
    attrs: {
      "dark": "",
      "height": "34px"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "call-title"
  }, [_vm._v(_vm._s(_vm.$t('calling')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('duration'))), (_vm.show) ? _c('chronometer') : _vm._e()], 1), _vm._v(" "), (_vm.isOnVideoCall) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.switchShowVideo
    },
    slot: "activator"
  }, [_c('v-icon', {
    domProps: {
      "textContent": _vm._s(_vm.showTextInput ? 'remove_red_eye' : 'notes')
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('write')))])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.mutebutton
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "mic-mute red--text darken-1",
    attrs: {
      "color": "#fff"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mute ? 'mic_off' : 'mic')
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mute ? _vm.$t('unmute') : _vm.$t('mute')))])], 1), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    staticClass: "hangup-button ma-0",
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    on: {
      "click": _vm.hangup
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticStyle: {
      "transform": "rotate(135deg)"
    }
  }, [_vm._v("phone")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('hangup')))])], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video),
      expression: "video"
    }],
    ref: "agentself",
    class: {
      'show': _vm.showVideo
    },
    attrs: {
      "id": "agentsCamera",
      "autoplay": "",
      "playsinline": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myCameraContainer"
    }
  }, [_c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video),
      expression: "video"
    }],
    ref: "myself",
    attrs: {
      "id": "myCamera",
      "autoplay": "",
      "playsinline": "",
      "muted": ""
    },
    domProps: {
      "muted": true
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1a99154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/call.vue
// module id = 413
// module chunks = 2